// The identity a device's push subscription is bound to (plan §8). Lives in its OWN IndexedDB database
// (`wd-push`) so the service worker can read it at push time with no page open. The server stamps every
// push with {uid, bk}; the worker compares them with this record and shows only a generic notice on a
// mismatch (shared devices: a push meant for the previous user must never show their content).
// Cleared on logout (onLogout hook + SW 'logout' message) and by Clear-Site-Data.
export interface PushIdentity {
  uid: string;
  bk: string;
  endpoint: string;
}
const DB = 'wd-push';
const STORE = 'identity';
const KEY = 'current';

function open(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    if (typeof indexedDB === 'undefined') return reject(new Error('no indexedDB'));
    const r = indexedDB.open(DB, 1);
    r.onupgradeneeded = () => r.result.createObjectStore(STORE);
    r.onsuccess = () => resolve(r.result);
    r.onerror = () => reject(r.error);
  });
}
async function run<T>(mode: IDBTransactionMode, fn: (s: IDBObjectStore) => IDBRequest<T>): Promise<T> {
  const db = await open();
  try {
    return await new Promise<T>((resolve, reject) => {
      const r = fn(db.transaction(STORE, mode).objectStore(STORE));
      r.onsuccess = () => resolve(r.result);
      r.onerror = () => reject(r.error);
    });
  } finally {
    db.close();
  }
}
export const getPushIdentity = () => run<PushIdentity | undefined>('readonly', (s) => s.get(KEY)).catch(() => undefined);
export const setPushIdentity = (v: PushIdentity) => run('readwrite', (s) => s.put(v, KEY)).then(() => undefined);
export const clearPushIdentity = () => run('readwrite', (s) => s.delete(KEY)).then(() => undefined).catch(() => undefined);
